export const headerText = [
  { text: '자동상품권교환', path: '/user/exchange' },
  { text: '실시간교환현황', path: '/user/realtime' },
  { text: '공지사항', path: '/user/notice' },
  { text: '자주묻는질문', path: '/user/faq' },
];
